import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { FormsUtils } from '../../shared/forms.utils';
import { DependentFieldFilters, Field } from '../../shared/interfaces/hubspot-form-data';
import { FormUtilsService } from '../../shared/services/form-utils.service';
import { HubspotOperators } from '../../shared/services/hubspot/hubspot-operators';
import { FormsService } from '../../shared/services/forms.service';
import { ValidatorUtils } from '../../shared/services/validator-utils';

@Component({
    selector: 'da-form-field-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent implements OnInit, OnDestroy {
    public field: Field;
    public group = null;
    public formId: string;
    private _$isSubmitting: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _inititalDependentFields: string;
    private _serviceSubscription: Subscription;

    constructor(
        private _hubspotOperators: HubspotOperators,
        private _formUtils: FormUtilsService,
        private _FormsService: FormsService,
        protected _ref: ChangeDetectorRef
    ) {}

    public get showErrors$(): Observable<boolean> {
        const _control = this.group.get(this.field.name);
        const _showErrors = _control.touched || this._$isSubmitting.getValue();
        return of(_showErrors);
    }

    onChecklistChange(checked: any, checkbox: { checked: any }) {
        checkbox.checked = checked;
        this.group.get(this.field.name).setValue(FormsUtils.flattenValuesFromCheckboxList(this.field.options));
    }

    ngOnInit() {
        this._inititalDependentFields = JSON.stringify(this.field.dependentFieldFilters);
        this._serviceSubscription = this._FormsService
            .submitting$(this.formId)
            .pipe(distinctUntilChanged())
            .subscribe((isSubmitting) => {
                if (isSubmitting) {
                    this.group.get(this.field.name).markAsTouched();
                    this._markDependentFieldsAsTouched();
                    this._ref.detectChanges();
                }
                this._$isSubmitting.next(isSubmitting);
            });
    }

    ngOnDestroy() {
        this._serviceSubscription.unsubscribe();
    }
    public getVisibilityByDependentFieldFiltersAndSetValidators(dependentField: DependentFieldFilters, parentField: AbstractControl) {
        const _isVisible = this._hubspotOperators.shouldBeVisible(dependentField, parentField, this.field);
        const _currentDependentField = this.group.get(dependentField.dependentFormField.name);
        const _currentDependentFieldIsRequiredWhenVisible = this._formUtils.isFieldInitiallyRequired(
            dependentField,
            this._inititalDependentFields
        );
        _currentDependentField.setValidators(
            ValidatorUtils.setValidatorsAgain(dependentField, _isVisible, _currentDependentFieldIsRequiredWhenVisible)
        );
        _currentDependentField.updateValueAndValidity();
        return _isVisible;
    }

    private _markDependentFieldsAsTouched() {
        this.field.dependentFieldFilters.forEach((filter) => this.group.get(filter.dependentFormField.name).markAsTouched());
    }

    public getErrorTranslation(error: any): string {
        return this._formUtils.getErrorTranslation(error, this.group, this.field);
    }
}
